import { RestApiMiddleware } from '@shared/store/middleware';

export const middlewares = [RestApiMiddleware];
